import { render, staticRenderFns } from "./ServiceCreateFormComponent.vue?vue&type=template&id=16196e32"
import script from "./ServiceCreateFormComponent.vue?vue&type=script&lang=ts"
export * from "./ServiceCreateFormComponent.vue?vue&type=script&lang=ts"
import style0 from "./ServiceCreateFormComponent.vue?vue&type=style&index=0&id=16196e32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports